export default "__VITE_ASSET__zgqEgL8A__"